const backendUrl = process.env.NODE_ENV ==='production'
  ? 'https://solea-lykkehjulet-backend-prod.azurewebsites.net'
  : 'https://solea-lykkehjulet-backend-dev.azurewebsites.net';

export const startGame = gameId => `${backendUrl}/games/${gameId}/start`;
export const listGames = `${backendUrl}/list`;
export const pingBackend =`${backendUrl}/ping`;
export const pingBackendWithData = data => `${backendUrl}/ping/${data}`;
